const initialState = null;

const accountsReducer = (state = initialState, action) => {
    switch(action.type){
        case 'ACCOUNTS_LOAD_SUCCESS' : {
            return [
                ...action.payload.accounts
            ]
        }break;
        case 'ACCOUNTS_LOAD_FAIL' : {
            return [];
        }break;
        default : {
            return state;
        }break;
    }
}

export default accountsReducer;


// WEBPACK FOOTER //
// ./src/reducers/accountsReducer.js